import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/tools/social-media-calculator/page.tsx");
